<template>
    <transition name="slide">
        <div class="bottom-popup" v-if="value">
            <div class="rounded m-0 bg-white shadow-lg">
                <div class="px-8 pt-7 flex justify-between items-center">
                    <h3 class="n-color-text-weak text-md my-0 font-bold">{{ title }}</h3>
                    <button
                        type="button"
                        class="border-0 bg-transparent text-lg font-normal text-grey-700 hover:text-grey-800"
                        @click.prevent="$emit('input')"
                    >
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <!-- Main Content comes here -->
                <div class="px-8 py-7">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },

        value: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

